// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Upload,
    UploadFromJSON,
    UploadToJSON,
    User,
    UserFromJSON,
    UserToJSON,
    UserMinified,
    UserMinifiedFromJSON,
    UserMinifiedToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestCaseComment
 */
export interface TestCaseComment {
    /**
     * 
     * @type {number}
     * @memberof TestCaseComment
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TestCaseComment
     */
    testPlanId?: number;
    /**
     * 
     * @type {number}
     * @memberof TestCaseComment
     */
    parentId?: number;
    /**
     * 
     * @type {number}
     * @memberof TestCaseComment
     */
    project?: number;
    /**
     * 
     * @type {Array<Upload>}
     * @memberof TestCaseComment
     */
    attachments?: Array<Upload>;
    /**
     * 
     * @type {Array<User>}
     * @memberof TestCaseComment
     */
    mentions?: Array<User>;
    /**
     * 
     * @type {number}
     * @memberof TestCaseComment
     */
    testCase?: number;
    /**
     * 
     * @type {string}
     * @memberof TestCaseComment
     */
    comment: string;
    /**
     * 
     * @type {UserMinified}
     * @memberof TestCaseComment
     */
    createdBy: UserMinified;
    /**
     * 
     * @type {string}
     * @memberof TestCaseComment
     */
    createdAt?: string;
}

export function TestCaseCommentFromJSON(json: any): TestCaseComment {
    return {
        'id': json['id'],
        'testPlanId': !exists(json, 'testPlanId') ? undefined : json['testPlanId'],
        'parentId': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'project': !exists(json, 'project') ? undefined : json['project'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] as Array<any>).map(UploadFromJSON),
        'mentions': !exists(json, 'mentions') ? undefined : (json['mentions'] as Array<any>).map(UserFromJSON),
        'testCase': !exists(json, 'test_case') ? undefined : json['test_case'],
        'comment': json['comment'],
        'createdBy': UserMinifiedFromJSON(json['created_by']),
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function TestCaseCommentToJSON(value?: TestCaseComment): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'testPlanId': value.testPlanId,
        'parent_id': value.parentId,
        'project': value.project,
        'attachments': value.attachments === undefined ? undefined : (value.attachments as Array<any>).map(UploadToJSON),
        'mentions': value.mentions === undefined ? undefined : (value.mentions as Array<any>).map(UserToJSON),
        'test_case': value.testCase,
        'comment': value.comment,
        'created_by': UserMinifiedToJSON(value.createdBy),
        'created_at': value.createdAt,
    };
}


